import React from 'react'
import styles from 'elements/client.scss'
import Grail from '../elements/Grail'
import { EasinsureDisclaimer } from '../components/easinsure/disclaimer'

const ClientAppDom = ({navBar, content, noScroll}) => {
	return (
		<Grail
			header={navBar}
			content={
				<Grail
					{...{
						noScroll,
						content,
						wrapperClass: styles.limitWidth,
						footer: <EasinsureDisclaimer/>,
					}}
				/>
			}
			wrapperClass={styles.content}
		/>
	)
}
export default ClientAppDom



// WEBPACK FOOTER //
// ./elements/ClientAppDom.jsx